import { useCurrentProject } from '../projects/currentProject';
import { useProjectsScreen } from '../projects/projectsScreen-store';

/**
 * Current project name, top-left just right of the account blob (ProfileMenu sits
 * at top-4 left-4 with a 40px blob). Click → Projects screen. Moved here out of
 * the bottom action pill.
 */
export function ProjectNameChip() {
  const title = useCurrentProject((s) => s.title);
  return (
    <button
      onClick={() => useProjectsScreen.getState().openScreen()}
      className="fixed top-4 left-[60px] z-[60] flex h-10 max-w-[16rem] items-center truncate rounded-full bg-[var(--color-surface)] border border-[var(--color-border)] px-3.5 font-mono text-[14px] font-medium text-[var(--color-text)] shadow-[var(--shadow-1)] hover:bg-[color-mix(in_oklab,var(--color-text)_8%,transparent)] active:translate-y-px transition-[background,transform]"
      title="Projects (⌘O)"
      aria-label={`Project: ${title ?? 'none'} — open projects`}
    >
      {title ?? 'Projects'}
    </button>
  );
}
